module.exports = __webpack_public_path__ + "static/media/design-your-dream-castle.1935a860.png";